<template>
  <div
    data-app
    class="object-menu-container"
    :style="{ left: xPosition + 'px', top: yPosition + 'px' }"
    v-on-clickaway="closeWindow"
  >
    <object-menu-item :label="$t('ViewInMap')" @click.native="viewInMap" />

    <object-menu-item
      v-if="objectType === 'node'"
      :label="$t('ViewInSplicing')"
      @click.native="openSplicing"
    />

    <object-menu-item :label="$tc('Detail', 2)" @click.native="openZoomIn" />
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import ObjectMenuItem from "./ObjectMenuItem";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mapActions } from "vuex";
import utils from "@/utils";
import { bus } from "@/main";

export default {
  name: "NetworkDiagramObjectMenu",

  mixins: [clickaway, checkPermissionsMixin],

  components: {
    ObjectMenuItem
  },

  computed: {
    xPosition() {
      return this.$store.getters.getNetworkDiagramObjectMenuCoordinates
        .xPosition;
    },
    yPosition() {
      return this.$store.getters.getNetworkDiagramObjectMenuCoordinates
        .yPosition;
    },
    objectType() {
      return this.$store.getters.getNetworkDiagramSelectedObjectInfo.type;
    },
    nodeType() {
      return this.$store.getters.getNetworkDiagramSelectedObjectInfo.nodeType;
    },
    objectData() {
      return this.$store.getters.getNetworkDiagramSelectedObjectInfo.objectData;
    }
  },

  methods: {
    ...mapActions([
      "SET_OBJECT_TO_ZOOM_ON_MAP",
      "TOGGLE_NETWORK_DIAGRAM_ZOOM_IN",
      "CLOSE_NETWORK_DIAGRAM_OBJECT_MENU",
      "fetchObjectByUUID",
      "SET_ACTIVE_FIBERCLOUD_TAB",
      "UPDATE_SELECTED_OBJECT_DATA"
    ]),

    /**
     * View object centered and zoomed in in the map of the OSP tab
     */
    async viewInMap() {
      let objectData;
      let coordsGeoJson;

      if (this.objectType === "cable") {
        objectData = await this.fetchObjectData("cables", "cb", "conducts");
        coordsGeoJson = this.searchObjectField(objectData, "geo_json");
      } else {
        let endpoint;
        let prefix;
        let includes;

        if (this.nodeType.includes("Closure")) {
          endpoint = "closures";
          prefix = "cl";
          includes = "node";
        } else {
          endpoint = "technicallocals";
          prefix = "tl";
          includes = "technicalsite";
        }

        objectData = await this.fetchObjectData(endpoint, prefix, includes);
        if (prefix === "tl") {
          coordsGeoJson = objectData.technicalsite.node.nd_geo_json;
        } else {
          coordsGeoJson = objectData.node.nd_geo_json;
        }
      }

      if (coordsGeoJson) {
        await this.openGeomInMap(coordsGeoJson);
      }
    },

    async fetchObjectData(endpoint, prefix, includes) {
      try {
        let resp = await this.fetchObjectByUUID({
          endpoint: endpoint,
          objectUUID: this.objectData[prefix + "_uuid"],
          fieldsToInclude: includes
        });
        return resp.data.data[0];
      } catch (e) {
        let errorHandle = utils.errorHandler(e);
        if (errorHandle && typeof errorHandle === "string") {
          this.$toasted.global.toast_error(errorHandle);
        }
        this.closeWindow();
      }
    },

    async openGeomInMap(coordsGeoJson) {
      await this.SET_OBJECT_TO_ZOOM_ON_MAP(undefined);
      await this.SET_OBJECT_TO_ZOOM_ON_MAP(coordsGeoJson);
      let layoutMode = this.$store.getters.getActiveLayoutMode;
      if (layoutMode === 1) {
        this.SET_ACTIVE_FIBERCLOUD_TAB("home");
      }
      this.closeWindow();
    },

    searchObjectField(object, field) {
      for (const [key, value] of Object.entries(object)) {
        if (typeof value === "object" && value !== null) {
          let fieldFounded = this.searchObjectField(value, field);
          if (fieldFounded) return fieldFounded;
        }
        if (key.includes(field) && value) {
          return value;
        }
      }
    },

    /**
     * Opens the Splicing tab with the selected closure's info, when the user clicks the Move button.
     */
    async openSplicing() {
      let layer;
      let includes;

      if (this.nodeType.includes("Closure")) {
        layer = "fc_closure";
        includes = "technicalpoint,fiberterminalbox,images,node";
      } else {
        let specificTechnicalLocalType;

        switch (this.nodeType) {
          case "MDU":
            specificTechnicalLocalType = "mdu";
            break;

          case "Site":
            specificTechnicalLocalType = "site";
            break;

          case "FDC":
            specificTechnicalLocalType = "fdp";
            break;

          case "OLT":
            specificTechnicalLocalType = "olt";
            break;
        }

        layer = "fc_technical_local" + "_" + specificTechnicalLocalType;
        includes = "technicalsite";
      }

      if (layer) {
        let endpoint = this.$store.getters.getLayerEndpoint(layer);
        let prefix = this.$store.getters.getLayerInitials(layer);
        let objectData = await this.fetchObjectData(endpoint, prefix, includes);

        this.UPDATE_SELECTED_OBJECT_DATA(objectData);
        let layoutMode = this.$store.getters.getActiveLayoutMode;
        if (layoutMode === 1) {
          this.SET_ACTIVE_FIBERCLOUD_TAB("home");
        }
        bus.$emit("open-object-form", { layer, action: "splicing" });
      }
    },

    openZoomIn() {
      this.TOGGLE_NETWORK_DIAGRAM_ZOOM_IN(true);
      this.closeWindow();
    },

    closeWindow() {
      this.CLOSE_NETWORK_DIAGRAM_OBJECT_MENU();
    }
  }
};
</script>

<style scoped>
.object-menu-container {
  position: fixed;
  z-index: 25;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/ObjectMenu/ObjectMenu.vue